

import React from 'react';
import { useState, useEffect } from 'react';
import { StyleSheet, View, Text, Image, Button, TouchableOpacity, Animated, ImageBackground , Dimensions} from 'react-native';
import BtnCircle from '../components/buttons/BtnCircle';
import { PropsStackDiscBack, RootStackParamList } from './../types';
import { themePattern } from '../constants/pattern';
import { aminoacidos } from '../assets/aminoacidos';
import { FontAwesome } from '@expo/vector-icons';
const { width, height } = Dimensions.get('window')


const backgoundImage = require('./../assets/backgroud.png');

// Todas os gabaritos dos codons
const ala = require('./../assets/gabarito/ala.png');
const arg = require('./../assets/gabarito/arg.png');
const asn = require('./../assets/gabarito/asn.png');
const asp = require('./../assets/gabarito/asp.png');
const cys = require('./../assets/gabarito/cys.png');
const gln = require('./../assets/gabarito/gln.png');
const glu = require('./../assets/gabarito/glu.png');
const gly = require('./../assets/gabarito/gly.png');
const his = require('./../assets/gabarito/his.png');
const ile = require('./../assets/gabarito/ile.png');
const leu = require('./../assets/gabarito/leu.png');
const lys = require('./../assets/gabarito/lys.png');
const met = require('./../assets/gabarito/met.png');
const phe = require('./../assets/gabarito/phe.png');
const pro = require('./../assets/gabarito/pro.png');
const ser = require('./../assets/gabarito/ser.png');
const thr = require('./../assets/gabarito/thr.png');
const trp = require('./../assets/gabarito/trp.png');
const tyr = require('./../assets/gabarito/tyr.png');
const val = require('./../assets/gabarito/val.png');

const imganesAminoacidos = [ala, arg, asn, asp, cys,phe, gly,glu, gln,   his, ile, leu, lys, met, pro, ser, tyr,thr, trp,  val]



export default function DiscBack({ route, navigation }: PropsStackDiscBack) {

  // Controle de parametros de navegação
  let aminoAcid = 0
  console.log(route);

  if (route.params) {
    aminoAcid = route.params.aminoAcid;
  }

  const [count, setCount] = useState(aminoAcid);
  useEffect(() => {
    transition(count)
    transitionFade(count)
  });


  // Função Referencia Navegação
  let openModalInfo = () => {
    navigation.navigate('ModelInfo', { aminoAcid: count }) // open drawer
  };

  let openModalTri = () => {
    navigation.navigate('ModelTri', { aminoAcid: count }) // open drawer
  };

  let openModalFront = () => {
    console.log(count);

    navigation.navigate('DiscFront', { aminoAcid: count }) // open drawer
  };


  //Assets
  let aminoacidosDisc = require('./../assets/discoverso.png');
  let base = require('./../assets/base.png');

  //Controle de switch Aminoacidos
  const { name } = aminoacidos(count)
  function next() {
    if (count === 19)
      setCount(0)
    else
      setCount(count + 1)
  }

  function prev() {
    if (count === 0)
      setCount(19)
    else
      setCount(count - 1)


  }



  // Animação rotação
  const pontos = ['190deg', '325deg', '262deg', '173deg', '61deg', '129deg', '145deg', '164deg', '342deg', '355deg', '306deg', '34deg', '251deg', '294deg', '11deg', '241deg', '84deg', '280deg', '48deg', '211deg']



  const [rotacao, setRotacao] = useState(new Animated.Value(count));
  const [fade, setFade] = useState(new Animated.Value(count));

  const spin = rotacao.interpolate({
    inputRange: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
    outputRange: pontos
  })

  

  function transition(value: number) {
    Animated.timing(
      rotacao,
      {
        toValue: value,
        duration: 1000,
        useNativeDriver: false
      }
    ).start();
  }

  function transitionFade(value: number) {
    Animated.sequence([
      Animated.timing(
      fade,
      {
        toValue: 0,
        duration: 0,
        useNativeDriver: false
      }
    ),
    Animated.timing(
      fade,
      {
        toValue: 1,
        delay:1000,
        duration: 1000,
        useNativeDriver: false
      }
    ),
  ]).start();
  }


  return (
    <ImageBackground source={backgoundImage} resizeMode="cover" style={{
      flex: 1,
      justifyContent: "center",
      zIndex:-10
    }}>
      <View style={styles.Main}>
        <View style={stylesDisc.container}>

          <View style={stylesDisc.containerTitle}>
            <View style={stylesDisc.display}>
              <Text style={stylesDisc.title}>{name}</Text>
            </View>
          </View>

          <View style={stylesDisc.containerDisc}>


            <View style={stylesDisc.imagens} >
              <Image source={base} style={stylesDisc.base} resizeMode='contain' />
              

              <Animated.Image source={aminoacidosDisc} style={[{ transform: [{ rotate: spin }] }, stylesDisc.aminoacidos]} resizeMode='contain' />
              <Animated.Image source={imganesAminoacidos[count]} style={[stylesDisc.aminoacidoImage,{opacity:fade}]} resizeMode='contain' />
            </View>


            <View style={stylesDisc.containerControl}>
              <View style={stylesDisc.control}>
                <TouchableOpacity
                  onPress={() => prev()}
                  style={stylesButton.btn}
                >
                  <View style={[{ borderTopWidth: 5 }, stylesButton.iconContainer]}>
                    <View style={stylesButton.icon}>
                      <FontAwesome

                        name="arrow-up"
                        style={
                          stylesButton.iconFont
                        }

                      />
                    </View>
                  </View>
                </TouchableOpacity>
                <Text>
                  <FontAwesome

                    name="caret-left"
                    style={
                      stylesButton.iconFont
                    }

                  />
                </Text>
                <TouchableOpacity
                  onPress={() => next()}
                  style={stylesButton.btn}
                >
                  <View style={[{ borderBottomWidth: 5 }, stylesButton.iconContainer]}>
                    <View style={stylesButton.icon}>
                      <FontAwesome

                        name="arrow-down"
                        style={
                          stylesButton.iconFont
                        }

                      />
                    </View>
                  </View>
                </TouchableOpacity>
              </View>
            </View>
          </View>


        </View>

        <View style={styles.Buttons}>
          <BtnCircle
            icon="info"
            name="INFORMAÇÃO"
            onPress={() => openModalInfo()}
          />

          <BtnCircle
            icon="cubes"
            name="VISUALIZAÇÃO"
            onPress={() => openModalTri()}
          />

          <BtnCircle
            icon="refresh"
            name="PLANAR"
            onPress={() => openModalFront()}
          />
        </View>

      </View>
    </ImageBackground>
  );
}
const styles = StyleSheet.create({
  Main: {
    flex: 1,
    justifyContent: 'space-evenly',
    flexDirection: 'column',
    overflow:'hidden'
  },
  Disc: {
    flexGrow: 1
  },
  Buttons: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    backgroundColor: themePattern.mobile.white,
    padding: 15
  }
});

const stylesButton = StyleSheet.create({
  btn: {
    alignItems: "center",
  },
  icon: {
    width: "100%",
    height: "100%",

    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',




    alignItems: "center",

  },
  iconFont: {
    color: themePattern.mobile.white,
    fontSize: 32
  },
  iconContainer: {
    backgroundColor: themePattern.mobile.color1,
    color: themePattern.mobile.white,
    width: 46,
    height: 46,
    borderRadius: 50,

    borderColor: themePattern.mobile.scolor2,
    borderWidth: 1,



  }
});

function Styles() {

  //Mobile
  if(themePattern.breakpoint.mobile >= width)
    return  StyleSheet.create({
      container: {
        flex: 1,
        flexDirection: 'column',
        padding: 15
      },
      containerTitle: {
        backgroundColor: themePattern.mobile.color1,
        borderRadius: 10,
        padding: 10,
    
      },
      containerDisc: {
        flex: 1,
        flexGrow: 1,
        flexDirection: 'row',
      },
    
      display: {
        backgroundColor: themePattern.mobile.white,
        padding: 5,
        borderRadius: 10
      },
      title: {
        fontSize: themePattern.mobile.title2,
        textAlign: "center",
        fontWeight: 'bold'
      },
    
      imagens: {
        flexGrow: 1,
        justifyContent: "center",
        alignItems: "center",
        position: "relative"
      },
      aminoacidoImage: {
        width: "98%",
        height: "98%",
        right: "1%",
        top:"1%",
        position: 'absolute',
        zIndex: 3
      },
      aminoacidos: {
        width: "98%",
        height: "98%",
        position: 'absolute',
        zIndex: 2
    
      },
      base: {
        width: "100%",
        height: "100%",
        position: 'absolute'
      },
    
      containerControl: {
        justifyContent: 'center',
        marginLeft: 10,
        zIndex: 10
      },
      control: {
        justifyContent: 'space-evenly',
        backgroundColor: themePattern.mobile.color1,
        height: 250,
        padding: 5,
        borderRadius: 10,
      },
    
    
    
    });
  //Tablet
  else
  return  StyleSheet.create({
    container: {
      flex: 1,
      flexDirection: 'column',
      padding: 15
    },
    containerTitle: {
      backgroundColor: themePattern.mobile.color1,
      borderRadius: 10,
      padding: 10,
  
    },
    containerDisc: {
      flex: 1,
      flexGrow: 1,
      flexDirection: 'row',
    },
  
    display: {
      backgroundColor: themePattern.mobile.white,
      padding: 5,
      borderRadius: 10
    },
    title: {
      fontSize: themePattern.mobile.title2,
      textAlign: "center",
      fontWeight: 'bold'
    },
  
    imagens: {
      flexGrow: 1,
      justifyContent: "center",
      alignItems: "center",
      position: "relative"
    },
    aminoacidoImage: {
      width: "98%",
      height: "98%",
      right: "1%",
      top:"1%",
      position: 'absolute',
      zIndex: 2
    },
    aminoacidos: {
      width: "98%",
      height: "98%",
      position: 'absolute',
      zIndex: 3
  
    },
    base: {
      width: "100%",
      height: "100%",
      position: 'absolute'
  
    },
  
    containerControl: {
      justifyContent: 'center',
      marginLeft: 10,
      zIndex: 10
    },
    control: {
      justifyContent: 'space-evenly',
      backgroundColor: themePattern.mobile.color1,
      height: 250,
      padding: 5,
      borderRadius: 10,
    },
  
  
  
  });
}

const stylesDisc =  Styles()